export const GAME_VOLATILITY_OPTIONS = [
  'Very Low',
  'Low',
  'Medium',
  'High',
  'Very High',
] as const;

export const GAME_RTP_TYPE_OPTIONS = [
  'Balanced Return',
  'Standard Return',
  'High Return',
] as const;

export const GAME_TOP_PRIZE_OPTIONS = [
  'Low',
  'Medium',
  'High',
  'Very High',
  'Insane',
] as const;

export const GAME_BET_LEVEL_OPTIONS = [
  'Micro',
  'Low',
  'Standard',
  'High',
  'Very High',
  'VIP',
] as const;

export const GAME_PROMO_TOOL_OPTIONS = [
  'Free Spins',
  'Free Spins Multiplier',
  'Jackpots',
  'Tournaments & Contests',
  'Prize Drops',
  'Loyalty & VIP',
] as const;

export const GAME_JACKPOT_TYPE_OPTIONS = [
  'Fixed Jackpots',
  'Progressive Jackpots',
  'Tiered Jackpots',
  'Must Drop Jackpots',
] as const;

export const GAME_SUB_JACKPOT_TYPE_OPTIONS = [
  'Fixed Jackpots',
  'Progressive',
  'Grand Jackpot',
  'Must Drop',
] as const;
